import { format } from 'date-fns';

import { Task } from '@atom/types/task';

import TaskCompletionIcon from './TaskCompletionIcon';

import classes from './workSummaryTray.module.css';

interface Props {
  task: Task;
}

const TaskRow = ({ task }: Props) => {
  const dueDateText = task?.dueDate ? format(task?.dueDate, 'MM/dd/yyyy') : '-';

  return (
    <div className={classes.taskRowContainer}>
      <TaskCompletionIcon isCompleted={task?.isCompleted} />
      <div className={classes.taskRowContent}>
        <div className={classes.taskRowDescription}>{task?.name}</div>
        <div className={classes.taskRowDetailsContainer}>
          <div className={classes.taskDetailContent}>
            {`Due Date: ${dueDateText}`}
          </div>
          <div className={classes.taskDetailContent}>
            Team: {task?.users?.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskRow;
